import { z } from 'zod';

export const FormTemplateSchema = z.object({
    id: z.string().optional(),
    name: z.string().min(1),
    code: z.string().optional(),
    description: z.string().optional(),
    category: z.string().optional(),
    templateKind: z.enum(['form', 'survey']).optional(),
    surveySchemaVersion: z.number().int().min(1).optional(),
    surveyDefinition: z.any().optional(),
    schema: z.any().optional(), // JSON Schema or form builder config
    fields: z.array(z.object({
        id: z.string().optional(),
        name: z.string().optional(),
        label: z.string().optional(),
        type: z.string().optional(),
        required: z.boolean().optional(),
        placeholder: z.string().optional(),
        helpText: z.string().optional(),
        options: z.array(z.object({
            label: z.string().optional(),
            value: z.string().optional()
        })).optional(),
        validation: z.object({
            min: z.number().optional(),
            max: z.number().optional(),
            pattern: z.string().optional(),
            message: z.string().optional()
        }).optional(),
        order: z.number().optional()
    })).optional(),
    status: z.string().default('draft'), // draft, published, archived
    requiresApproval: z.boolean().default(false),
    assignmentTemplateId: z.string().optional(),
    notifyOnSubmit: z.array(z.string()).optional(), // User IDs or emails
    createdAt: z.date().optional(),
    updatedAt: z.date().optional(),
});

export const CreateFormTemplateSchema = FormTemplateSchema.omit({ id: true, createdAt: true, updatedAt: true });
export const UpdateFormTemplateSchema = FormTemplateSchema.partial();

export const formFormSchema = z.object({
    documentName: z.string().min(1, "form.validation.documentNameRequired"),
    documentVersion: z.string().min(1, "form.validation.documentVersionRequired"),
    recordedBy: z.string().min(1, "form.validation.recordedByRequired"),
    recordStamp: z.string().optional(),
    documentType: z.string().optional(),
    documentCode: z.string().optional(),
    confidentialityLevel: z.string().optional(),
    uploadDate: z.union([z.string(), z.date()]).optional(),
    filePath: z.string().optional(),
    isActive: z.boolean().optional(),
});

export const documentSelectionSchema = z.object({
    documentId: z.coerce.number().min(1, "form.validation.documentSelectionRequired"),
});
